import { render, staticRenderFns } from "./SrModalPageFormTabFooter.vue?vue&type=template&id=3af63730"
import script from "./SrModalPageFormTabFooter.vue?vue&type=script&lang=js"
export * from "./SrModalPageFormTabFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports